import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Table } from 'components';
import { Button } from 'components/_form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IPlatformMethodology } from 'types/platformResources';

const Buttons = styled(Flex)`
  width: fit-content;
  margin: 0 auto;
  gap: 8px;
`;

interface Props {
  methodologies: IPlatformMethodology[];
  practiceCounts: Record<number, number>;
  onOpen: (methodology: IPlatformMethodology) => void;
  onEdit: (methodology: IPlatformMethodology) => void;
}

export const PlatformMethodologiesTable: React.FC<Props> = ({
  methodologies,
  practiceCounts,
  onOpen,
  onEdit
}) => {
  const { t } = useTranslation();

  const sorted = useMemo(
    () => [...methodologies].sort((a, b) => a.name.localeCompare(b.name)),
    [methodologies]
  );

  const header = [
    t('platformResources.tableHeaders.name'),
    t('platformResources.tableHeaders.practicesCount'),
    ''
  ];

  const data = useMemo(
    () =>
      sorted.map((methodology) => ({
        name: (
          <Button
            key={`name-${methodology.id}`}
            bordered
            transparent
            onClick={() => onOpen(methodology)}
          >
            {methodology.name}
          </Button>
        ),
        count: practiceCounts[methodology.id] ?? 0,
        actions: (
          <Buttons key={`actions-${methodology.id}`}>
            <Button
              variant="eucalyptus"
              icon={<FontAwesomeIcon icon={faPenToSquare} />}
              onClick={() => onEdit(methodology)}
            />
          </Buttons>
        )
      })),
    [sorted, practiceCounts, onOpen, onEdit]
  );

  return <Table header={header} data={data} sortTable={false} rightFixedKeys={[2]} />;
};
